
export const mapSrc = (activeLevel) => {
  switch (activeLevel) {
    case 0: return 'https://files.peakd.com/file/peakd-hive/keys-defender/48KbB9tBkiH7AFsBRkNXjmVZos8K9rQ9cU8Th5GALXgr5Xwr6YvEnNceJmULnkZAJv.png';
    case 1: return 'https://files.peakd.com/file/peakd-hive/keys-defender/48PvpQBSpgvbmP9equTqq6GoM7BAJgPfSY3NDC1hbQfwtr3DtRH6FAR2eoWx17p491.png';
    case 2: return 'https://files.peakd.com/file/peakd-hive/cryptoshots.nft/48J8T2kNPmJVaiWHA5G3NHLqRuH4eLd8UkwAvk1FXnYqukHRSVLgo469kzvrdy4cYz.png';
    default: { console.error('MAP IMAGE NOT FOUND FOR LEVEL', activeLevel); }
  }
};
